import type { ExpiryMonths } from '#shared/constants';
import { listingDisplayName } from '#shared/listingIdentity';
import type { ListingRecord } from '#shared/types';

export type ListingFieldUpdates = Pick<
  ListingRecord,
  | 'name'
  | 'serviceType'
  | 'phone'
  | 'email'
  | 'website'
  | 'blurb'
  | 'expiryMonths'
>;

export type ListingFieldValues = {
  name: string;
  serviceType: string;
  phone: string;
  email: string;
  website: string;
  blurb: string;
  expiryMonths: string;
};

export const toFieldUpdates = (
  fields: ListingFieldValues,
): ListingFieldUpdates => ({
  name: fields.name.trim() || undefined,
  serviceType: fields.serviceType.trim() || undefined,
  phone: fields.phone.trim() || undefined,
  email: fields.email.trim() || undefined,
  website: fields.website.trim() || undefined,
  blurb: fields.blurb.trim() || undefined,
  expiryMonths: Number(fields.expiryMonths) as ExpiryMonths,
});

export const hasFieldUpdates = (updates: ListingFieldUpdates): boolean =>
  Object.values(updates).some((value) => value !== undefined);

export const listingToFieldValues = (
  listing: ListingRecord,
): ListingFieldValues => ({
  name: listingDisplayName(listing) ?? '',
  serviceType: listing.serviceType ?? '',
  phone: listing.phone ?? '',
  email: listing.email ?? '',
  website: listing.website ?? '',
  blurb: listing.blurb ?? '',
  expiryMonths: String(listing.expiryMonths ?? 12),
});

export const emptyListingFieldValues = (): ListingFieldValues => ({
  name: '',
  serviceType: '',
  phone: '',
  email: '',
  website: '',
  blurb: '',
  expiryMonths: '12',
});
